"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var bind_1 = require("../bind");
var SearchInputGroup = /** @class */ (function (_super) {
    tslib_1.__extends(SearchInputGroup, _super);
    function SearchInputGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchInputGroup.prototype.clearInputValue = function () {
        this.textInput && this.textInput.focus();
        this.props.onChange({ target: { value: '' } });
        this.props.onClear && this.props.onClear();
    };
    SearchInputGroup.prototype.bindInputRef = function (node) {
        if (!node) {
            return;
        }
        this.textInput = node;
    };
    SearchInputGroup.prototype.renderClearButton = function () {
        if (!this.props.value) {
            return;
        }
        return (React.createElement("a", { className: "search-input-group__clear", onClick: this.clearInputValue }));
    };
    SearchInputGroup.prototype.render = function () {
        var classes = classNames('search-input-group', { 'search-input-group--large': this.props.large });
        return (React.createElement("div", { className: classes },
            React.createElement("form", { onSubmit: this.props.onSubmit, action: this.props.action },
                React.createElement("div", { className: "search-input-group__inner" },
                    React.createElement("div", { className: "search-input-group__field" },
                        React.createElement("input", { type: "text", value: this.props.value, onChange: this.props.onChange, placeholder: this.props.placeholder, ref: this.bindInputRef, autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false, id: this.props.id, name: this.props.name }),
                        this.renderClearButton()),
                    React.createElement("button", { className: "search-input-group__button", type: "submit" })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], SearchInputGroup.prototype, "clearInputValue", null);
    tslib_1.__decorate([
        bind_1.default
    ], SearchInputGroup.prototype, "bindInputRef", null);
    return SearchInputGroup;
}(React.Component));
exports.default = SearchInputGroup;
//# sourceMappingURL=search_input_group.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/search_input_group.js
// module id = am2Z
// module chunks = 0 1 2 3 6 8 9 10 14 20